import React from 'react';
import Report from './Report.svg';

export default props => <img src={Report} alt="report" {...props} />;
